import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext'; 
import ToastProvider from './components/ToastProvider';
import Navbar from './components/Navbar';
import GenderSelection from './pages/GenderSelection';
import SearchSalons from './pages/SearchSalons';
import Booking from './pages/Booking';
import Login from './pages/Login';
import Register from './pages/Register';
import ClientDashboard from './pages/ClientDashboard';
import SalonDashboard from './pages/SalonDashboard';
import AdminDashboard from './pages/AdminDashboard';
import FranchiseeDashboard from './pages/FranchiseeDashboard';
import NotFound from './pages/NotFound';
import EditProfile from './pages/EditProfile';
import './styles/App.css';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth(); 

  if (loading) return <div>Ładowanie...</div>;

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {

    return <Navigate to={`/dashboard/${user.role}`} replace />;
  }

  return children;
};

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <Router>
          <div className="App">
            <Navbar />
            <Routes>
              <Route path="/" element={<GenderSelection />} />
              <Route path="/search/:gender" element={<SearchSalons />} />
              <Route path="/booking/:salonId" element={<Booking />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              
              <Route path="/dashboard/client" element={
                <ProtectedRoute allowedRoles={['client']}><ClientDashboard /></ProtectedRoute>
              } />
              <Route path="/dashboard/salon" element={
                <ProtectedRoute allowedRoles={['salon']}><SalonDashboard /></ProtectedRoute>
              } />
              <Route path="/dashboard/admin" element={
                <ProtectedRoute allowedRoles={['admin']}><AdminDashboard /></ProtectedRoute>
              } />
              <Route path="/dashboard/franchisee" element={
                <ProtectedRoute allowedRoles={['franchisee']}><FranchiseeDashboard /></ProtectedRoute>
              } />
              
              <Route path="/profile" element={
                <ProtectedRoute><EditProfile /></ProtectedRoute>
              } />

              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </Router>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;